import React from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from 'common/helmets/Helmet';

const Title = 'Jane Technologies Case Study | Canny';
const Description =
  'Read about how Jane Technologies streamlined user feedback and boosted company culture.';
const Image = 'https://canny.io/images/7bbea23270aac533fadddc907b49e1e7.jpg';
const JanetechnologiesUrl = 'https://canny.io/case-studies/janetechnologies';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${JanetechnologiesUrl}#webpage`,
    url: JanetechnologiesUrl,
    name: 'Case Study: Jane Technologies × Canny',
    description: 'How Jane Technologies streamlined user feedback and boosted company culture.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${JanetechnologiesUrl}#article`,
    genre: 'Case Study',
    headline: 'How Jane Technologies streamlined user feedback and boosted company culture',
    description:
      'Jane Technologies replaced their ClickUp-based feedback system—described as a "black hole of lists"—with Canny. The switch saved the product team hours each week, enabled sales teams to log feedback immediately via integrated workflows, and increased organizational visibility into customer requests.',
    inLanguage: 'en',
    url: JanetechnologiesUrl,
    mainEntityOfPage: { '@id': `${JanetechnologiesUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'Jane Technologies', url: 'https://iheartjane.com' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'Jane Technologies', item: JanetechnologiesUrl },
  ]),
]);

const JaneTechnologiesLandingHelmet = () => {
  return (
    <Helmet
      title={Title}
      meta={[
        { name: 'description', content: Description },

        { property: 'og:image', content: Image },
        { property: 'og:title', content: Title },
        { property: 'og:description', content: Description },
        { property: 'og:url', content: JanetechnologiesUrl },
        { property: 'og:type', content: 'website' },

        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@cannyHQ' },
        { name: 'twitter:title', content: Title },
        { name: 'twitter:description', content: Description },
        { name: 'twitter:image', content: Image },
      ]}>
      <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
    </Helmet>
  );
};

export default JaneTechnologiesLandingHelmet;
